module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "width": "18",
      "height": "18",
      "viewBox": "0 0 256 256",
      "xml:space": "preserve"
    }
  }, [_c('desc', [_vm._v("Created with Fabric.js 1.7.22")]), _c('defs'), _c('g', {
    attrs: {
      "transform": "translate(128 128) scale(0.72 0.72)"
    }
  }, [_c('g', {
    staticStyle: {
      "stroke": "none",
      "stroke-width": "0",
      "stroke-dasharray": "none",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "fill": "none",
      "fill-rule": "nonzero",
      "opacity": "1"
    },
    attrs: {
      "transform": "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
    }
  }, [_c('path', {
    staticStyle: {
      "stroke": "none",
      "stroke-width": "1",
      "stroke-dasharray": "none",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "fill": "#7665cd",
      "fill-rule": "nonzero",
      "opacity": "1"
    },
    attrs: {
      "d": "M 45 90 c -6.075 0 -11 -4.925 -11 -11 V 11 c 0 -6.075 4.925 -11 11 -11 s 11 4.925 11 11 v 68 C 56 85.075 51.075 90 45 90 z",
      "transform": " matrix(1 0 0 1 0 0) ",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    staticStyle: {
      "stroke": "none",
      "stroke-width": "1",
      "stroke-dasharray": "none",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "fill": "#7665cd",
      "fill-rule": "nonzero",
      "opacity": "1"
    },
    attrs: {
      "d": "M 79 56 H 11 C 4.925 56 0 51.075 0 45 s 4.925 -11 11 -11 h 68 c 6.075 0 11 4.925 11 11 S 85.075 56 79 56 z",
      "transform": " matrix(1 0 0 1 0 0) ",
      "stroke-linecap": "round"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41b87fb3","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/slimPlus.vue
// module id = 102c57b55ff4f4b1e018
// module chunks = 89